const resource = {
    resource_identifier_in_use: 'API 식별자 {{indicator}}가 이미 사용 중입니다',
};
export default Object.freeze(resource);
